import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './loginButton.scss';

function LoginButton({ className, history }) {
  const auth = useAuth0();

  function onLoginWithRedirect() {
    auth.loginWithRedirect({
      appState: { targetUrl: history.location.pathname },
    });
  }

  return (
    <a
      className={
        (className = `${styleHelper.btnPrimaryMd} ${styles.loginButton}`)
      }
      onClick={onLoginWithRedirect}
    >
      LOGGA IN
    </a>
  );
}

LoginButton.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};

export default withRouter(LoginButton);
